// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__MM2Ne","col":"Table_col__28_U8","fulfillmentStatus":"Table_fulfillmentStatus__3Btjv","emailCol":"Table_emailCol__1yGmO"};